import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import { isAndroid, isFirefox, isIOS } from "react-device-detect";

import { Button } from "@/components/index";

const LinkButton = ({ href, shallow = true, linkAs, idRipple, ...props }) => {
  if (!href) {
    return <Button idRipple={idRipple} {...props} />;
  }

  const linkProps = {
    href,
    // Prevent displaying a native context menu of a link on Android device in Firefox browser,
    // by preventing passing "href" attribute.
    passHref: !(isAndroid && isFirefox),
  };

  if (linkAs) {
    linkProps["as"] = linkAs;
  }

  return (
    <Link shallow={shallow} {...linkProps} scroll={false} legacyBehavior={true}>
      {/*timeout 615ms - tested to be OK on Iphone 13, IOS 15.4.1*/}
      <Button idRipple={idRipple} timeout={isIOS ? 615 : undefined} rootTagName="a" {...props} />
    </Link>
  );
};

LinkButton.variant = Button.variant;
LinkButton.color = Button.color;
LinkButton.size = Button.size;

LinkButton.propTypes = {
  ...Button.propTypes,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  idRipple: PropTypes.string,
  linkAs: PropTypes.string,
};

export default LinkButton;
